import { UserManager, WebStorageStateStore, type User } from "oidc-client-ts";
import { config, redirectUri } from "../models/config";

// A single UserManager drives the Authorization Code + PKCE flow against Keycloak (dev) — and,
// later, against compath-auth unchanged (both are OIDC providers).
export const userManager = new UserManager({
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: redirectUri,
  // Trailing slash so it matches Keycloak's "…/*" post-logout allow-list (a bare origin without the
  // slash is rejected). Lands on "/", where the app bounces to the Keycloak login.
  post_logout_redirect_uri: window.location.origin + "/",
  response_type: "code",
  scope: "openid profile",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
});

export interface Principal {
  id: string;
  name: string;
  groups: string[];
}

export function principalFromUser(user: User): Principal {
  const p = user.profile as Record<string, unknown>;
  const groups = Array.isArray(p.groups) ? (p.groups as string[]) : [];
  return {
    id: String(p.sub ?? ""),
    // Never fall back to `sub` — a raw subject UUID as the titlebar name tells the user nothing.
    name: String(p.name ?? p.preferred_username ?? p.email ?? "사용자"),
    groups,
  };
}

export const isAdmin = (p: Principal) =>
  p.groups.some((g) => g === "sp-admin" || g === "admin");
